import React, { useState, useCallback, useEffect, useRef } from 'react';
import search from '../../../../images/search.svg';
import edit from '../../../../images/edit.svg';
import save from '../../../../images/check-circle.svg';
import filter from '../../../../images/filter.svg';
import pointerDown from '../../../../images/pointer-down.svg';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Controller } from 'react-hook-form';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import {
  capitalize,
  translateStatus,
} from '../../../../assets/helpers/funciones';
import { providerStatus } from '../../../../assets/helpers/options';
import copyImage from '../../../../images/copyImage.svg';
import checkbox from '../../../../images/checkbox.svg';
import checkboxChecked from '../../../../images/checkboxChecked.svg';
import checkboxIndeterminate from '../../../../images/checkboxIndeterminate.svg';
import { Dropzone, FileComponent } from '../../Dropzone/Dropzone';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDropzone } from 'react-dropzone';
import { returnIGTF } from '../../../../assets/helpers/funciones';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import { notify } from '../../../../assets/helpers/toast';
import eye from '../../../../images/eye.svg';
import eyeOff from '../../../../images/eye-off-outline.svg';

import './Input.scss';
registerLocale('es', es);

export const FilterDatePicker = (props) => {
  const {
    label,
    bootstrap,
    minDate,
    maxDate,
    filterDate,
    data,
    name,
    placeholder,
    value,
    onChange,
    disabled,
  } = props;
  return (
    <div className={`input-component-container ${bootstrap}`}>
      {data?.subLabel && !label ? '' : <label htmlFor={name}>{label}</label>}

      <div>
        <div className="input-sublabel-container">
          {data?.subLabel && <h6>{data?.subLabel}</h6>}
          <DatePicker
            dateFormat="dd/MM/yyyy"
            placeholderText={placeholder}
            onChange={onChange}
            selected={value}
            name="Hasta"
            locale="es"
            autoComplete="off"
            minDate={minDate || data?.minDate}
            maxDate={maxDate || data?.maxDate}
            filterDate={filterDate || data?.filterDate}
            disabled={disabled || data?.disabled}
          />
        </div>
      </div>
    </div>
  );
};

// EYE component that shows or hyde password
export const ShowPassword = (props) => {
  const { type, inputType, showPassword } = props;

  if (type === 'password' && inputType !== 'text') {
    return (
      <img
        className="eye-component"
        src={eye}
        alt="eye"
        onClick={showPassword}
      />
    );
  }
  if (type === 'password' && inputType === 'text') {
    return (
      <img
        className="eye-component"
        src={eyeOff}
        alt="eyeOff"
        onClick={showPassword}
      />
    );
  } else return null;
};

export const SelectInput = (props) => {
  const {
    onChange,
    bootstrap,
    label,
    name,
    register,
    options,
    errors,
    disabled,
    capitalizeOff,
    errorInput,
    width,
    noBlankOption,
    centeredLabel,
  } = props;

  const { ref } = register(name);

  return (
    <div className={`input-component-container ${bootstrap}`}>
      <label
        htmlFor={name}
        style={{ textAlign: centeredLabel ? 'center' : 'left' }}
      >
        {label}
      </label>
      <div>
        <select
          style={{ width: width }}
          className={`input-select ${errorInput}`}
          onChange={onChange}
          {...register(name, {
            onChange: onChange,
          })}
          name={name}
          disabled={disabled}
        >
          {!noBlankOption && <option value=""></option>}
          {options?.map((o, i) => (
            <option key={o?._id} value={o?._id}>
              {capitalizeOff ? o?.name : capitalize(o?.name?.toLowerCase())}
            </option>
          ))}
        </select>
      </div>

      <p>{errors}</p>
    </div>
  );
};

export const Input = (props) => {
  const {
    bootstrap,
    label,
    type,
    title,
    name,
    register,
    placeholder,
    options,
    errors,
    data,
    subLabel,
    control,
    onChange,
    disabled,
    min,
    max,
    minDate,
    maxDate,
    capitalizeOff,
    width,
    hidden,
    noBlankOption,
    style,
    centeredLabel,
    numpadForMobile,
    rows = 1,
  } = props;

  const [inputType, setInputType] = useState(type);

  const showPassword = () => {
    inputType === 'password' ? setInputType('text') : setInputType('password');
  };

  let errorInput = 'i';
  if (errors) {
    errorInput = 'error-input';
  }

  if (title) {
    return (
      <>
        <div
          style={{ marginTop: '30px' }}
          className="filter-button-container"
        ></div>
        <h5 className="form-input-title">{title}</h5>
      </>
    );
  }

  if (type === 'checkbox') {
    return (
      <CheckboxInput
        subLabel={data?.subLabel || subLabel}
        bootstrap={bootstrap}
        label={label}
        name={name}
        register={register}
        errorInput={errorInput}
        errors={errors}
        onChange={onChange || data?.onChange}
        disabled={disabled || data?.disabled}
      />
    );
  }

  if (type === 'select') {
    return (
      <SelectInput
        noBlankOption={noBlankOption}
        width={width}
        options={data?.options || options}
        bootstrap={bootstrap}
        label={label}
        type={type}
        name={name}
        register={register}
        placeholder={placeholder}
        errors={errors}
        disabled={disabled || data?.disabled}
        onChange={onChange || data?.onChange}
        capitalizeOff={capitalizeOff}
        errorInput={errorInput}
        centeredLabel={centeredLabel}
      />
    );
  }

  if (type === 'phone') {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? '' : <label htmlFor={name}>{label}</label>}
        <Controller
          name={name}
          control={control}
          rules={{
            required: 'El teléfono es obligatorio',
            validate: (value) => {
              if (!value) return true;
              // Obtenemos el código de país (por defecto 58 si es VE)
              const countryCode = control._getWatch('countryCode') || '58';

              // Validamos que después del '+' y el código de país no se repita el código
              // Ejemplo: +5858... -> el resto sería "58..."
              const restOfNumber = value.replace(`+${countryCode}`, '');

              if (restOfNumber.startsWith(countryCode)) {
                return 'No repitas el código de área';
              }
              if (restOfNumber.startsWith('0')) {
                return 'No incluyas el 0 inicial';
              }
              return true;
            },
          }}
          render={({ field: { onChange, value } }) => (
            <PhoneInput
              inputMode={numpadForMobile ? 'tel' : 'text'}
              placeholder=""
              value={value}
              onChange={(val) => {
                let cleanValue = val;
                let countryCodeValue = '';

                try {
                  const parsedNumber = parsePhoneNumber(val);
                  if (parsedNumber) {
                    countryCodeValue = parsedNumber.countryCallingCode;

                    // --- FIX DE REPETICIÓN ---
                    // Si el número crudo contiene dos veces el countryCode al inicio
                    // Ejemplo: +5858414...
                    const rawValue = parsedNumber.number; // e.g. "+5858414..."
                    const doubleCode = `+${countryCodeValue}${countryCodeValue}`;

                    if (rawValue.startsWith(doubleCode)) {
                      // Removemos la repetición del string
                      cleanValue = rawValue.replace(
                        doubleCode,
                        `+${countryCodeValue}`
                      );
                    }
                  }
                } catch (err) {
                  countryCodeValue = '';
                }

                onChange(cleanValue);
                control._formValues.countryCode = countryCodeValue;
              }}
              defaultCountry={'VE'}
            />
          )}
        />
        <p>{errors}</p>
      </div>
    );
  }

  if (type === 'textarea') {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? '' : <label htmlFor={name}>{label}</label>}

        <div>
          <div className="input-sublabel-container">
            {data?.subLabel && <h6>{data?.subLabel}</h6>}
            <textarea
              rows={rows}
              id={name}
              className={`${errorInput} ${rows > 1 ? '' : 'textarea-min-25'}`}
              type={inputType}
              name={name}
              onChange={onChange}
              {...register(name, {
                onChange: onChange,
              })}
              placeholder={placeholder}
              autoComplete="off"
              disabled={disabled || data?.disabled}
            />
          </div>
        </div>

        <p>{errors}</p>
      </div>
    );
  }

  if (type === 'date') {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? (
          ''
        ) : (
          <label
            style={{ textAlign: centeredLabel ? 'center' : 'left' }}
            htmlFor={name}
          >
            {label}
          </label>
        )}
        <div className="input-sublabel-container">
          {data?.subLabel && <h6>{data?.subLabel}</h6>}
        </div>
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <DatePicker
              dateFormat="dd/MM/yyyy"
              placeholderText={'DD/MM/AAAA'}
              onChange={(date) => {
                field.onChange(date);
                onChange?.(date);
              }}
              selected={field.value}
              locale="es"
              autoComplete="off"
              minDate={minDate || data?.minDate}
              maxDate={maxDate || data?.maxDate}
              disabled={disabled || data?.disabled}
            />
          )}
        />
        <p>{errors}</p>
      </div>
    );
  }
  if (type === 'birthday') {
    return (
      <div className={`input-component-container ${bootstrap}`}>
        {data?.subLabel && !label ? '' : <label htmlFor={name}>{label}</label>}

        <div className="input-sublabel-container">
          {data?.subLabel && <h6>{data?.subLabel}</h6>}
        </div>
        <input
          id={name}
          className={`${errorInput}`}
          type={'date'}
          name={name}
          onChange={onChange}
          {...register(name, {
            onChange: onChange,
          })}
          placeholder={placeholder}
          autoComplete="off"
          disabled={disabled || data?.disabled}
          min={min || data?.min}
          max={max || data?.max}
        />
        <p>{errors}</p>
      </div>
    );
  }

  if (type === 'card-date') {
    <div
      className={`input-component-container ${bootstrap}`}
      style={{ visibility: hidden ? 'hidden' : 'visible' }}
    >
      {data?.subLabel && !label ? '' : <label htmlFor={name}>{label}</label>}

      <div style={{ width: width, visibility: hidden ? 'hidden' : 'visible' }}>
        <div className="input-sublabel-container">
          {subLabel && <h6 style={{ marginRight: '1rem' }}>{subLabel}</h6>}
          <input
            id={name}
            type={type}
            name={name}
            placeholder={placeholder}
            disabled={disabled}
            {...register(name, {
              onChange: onChange,
            })}
            onChange={onchange}
            maxLength={5}
          />
        </div>

        <ShowPassword
          type={type}
          inputType={inputType}
          showPassword={showPassword}
        />
      </div>

      <p>{errors}</p>
    </div>;
  }

  if (name) {
    return (
      <div
        className={`input-component-container ${bootstrap}`}
        style={{ visibility: hidden ? 'hidden' : 'visible' }}
      >
        {!label ? (
          <div style={{ height: '32px' }}></div>
        ) : (
          // center text in label
          <label
            style={{ textAlign: centeredLabel ? 'center' : 'left' }}
            htmlFor={name}
          >
            {label}
          </label>
        )}

        <div
          style={{ width: width, visibility: hidden ? 'hidden' : 'visible' }}
        >
          <div className="input-sublabel-container">
            {subLabel && <h6 style={{ marginRight: '1rem' }}>{subLabel}</h6>}
            <input
              inputMode={numpadForMobile ? 'decimal' : 'text'}
              id={name}
              style={style}
              className={`${errorInput}`}
              type={inputType}
              name={name}
              onChange={onChange}
              {...register(name, {
                onChange: onChange,
              })}
              placeholder={placeholder}
              autoComplete="off"
              disabled={disabled || data?.disabled}
              min={min || data?.min}
              max={max || data?.max}
              onWheel={
                inputType === 'number' ? (e) => e.target.blur() : undefined
              }
              onKeyDown={
                inputType === 'number'
                  ? (e) => {
                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                      e.preventDefault();
                    }
                  }
                  : undefined
              }
            />
          </div>

          <ShowPassword
            type={type}
            inputType={inputType}
            showPassword={showPassword}
          />
        </div>

        <p>{errors}</p>
      </div>
    );
  } else {
    return <div className={`input-component-container ${bootstrap}`}></div>;
  }
};

export const SelectPerPage = (props) => {
  const { options, label, value, onChange } = props;
  return (
    <div className="select-per-page">
      <label htmlFor="label">{label}</label>
      <select name="" id="label" onChange={(e) => onChange(e)} value={value}>
        {options?.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </div>
  );
};

export const Select = (props) => {
  const { options, label, value, onChange, disabled, capitalizeOff } = props;
  return (
    <div className="simple-select">
      <label htmlFor="label">{label}</label>
      <select
        disabled={disabled}
        name=""
        id="label"
        onChange={(e) => onChange(e)}
        value={value}
      >
        {options?.map((o) => (
          <option key={o?.name} value={o?._id}>
            {capitalizeOff ? o?.name : capitalize(o?.name)}
          </option>
        ))}
      </select>
    </div>
  );
};

export const SelectMultiple = ({ options, label, disabled, onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const clearFilters = () => {
    setSelectedValues([]);
    onSearch([]);
  };

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setSelectedValues((prevSelectedValues) =>
      prevSelectedValues.includes(value)
        ? prevSelectedValues.filter((v) => v !== value)
        : [...prevSelectedValues, value]
    );
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getDisplayText = () => {
    if (selectedValues.length === 0) {
      return 'Selecciona una opción';
    }
    return `${selectedValues.length} opción(es) seleccionada(s)`;
  };

  return (
    <div
      className="select-multiple-with-search"
      style={{ position: 'relative' }}
    >
      <label style={{ fontWeight: 'bold' }}>{label}</label>
      <div className="select-box" onClick={handleToggle}>
        {getDisplayText()}
        <img src={pointerDown} alt="pointerDown" className="pointer-icon" />
      </div>
      {isOpen && (
        <div
          className="dropdown-container"
          ref={dropdownRef}
          style={{ position: 'absolute', zIndex: 1000 }}
        >
          <div className="options-container-multiple">
            {options?.map((o) => (
              <div key={o?._id} className="option-multiple">
                <input
                  type="checkbox"
                  id={o?._id}
                  value={o?._id}
                  checked={selectedValues.includes(o?._id)}
                  onChange={handleOptionChange}
                  disabled={disabled}
                />
                <label htmlFor={o?._id}>{o?.name}</label>
              </div>
            ))}
          </div>
          <div className="buttons-container">
            <button
              className="search-button"
              disabled={disabled}
              onClick={() => onSearch(selectedValues)}
            >
              Buscar
            </button>
            <button
              className="clear-filters-button"
              onClick={clearFilters}
              disabled={selectedValues.length === 0 ? true : false}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * Generic multi-select dropdown filter.
 *
 * Props:
 *   label       {string}                  – Label shown above and inside the trigger when nothing is selected.
 *   options     {{ _id: string, name: string }[]} – Items to display. Provided by the parent/hook.
 *   onSearch    {(ids: string[]) => void}  – Called with selected IDs when "Buscar" is clicked,
 *                                            and with [] when "Limpiar" is clicked.
 *   isLoading   {boolean}                 – Shows a loading hint inside the trigger.
 *   disabled    {boolean}                 – Disables all interaction.
 *   placeholder {string}                  – Optional override for the "nothing selected" text.
 */
export const MultiSelectDropdown = ({
  label,
  options = [],
  onSearch,
  isLoading = false,
  disabled = false,
  placeholder,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = searchTerm
    ? options.filter((o) =>
      o?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : options;

  const handleOptionChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (e) => {
    setSelectedIds(e.target.checked ? filteredOptions.map((o) => o._id) : []);
  };

  const allFilteredSelected =
    filteredOptions.length > 0 &&
    filteredOptions.every((o) => selectedIds.includes(o._id));

  const handleSearch = () => {
    onSearch(selectedIds);
    setIsOpen(false);
  };

  const handleClear = () => {
    setSelectedIds([]);
    onSearch([]);
    setIsOpen(false);
  };

  const getDisplayText = () => {
    if (isLoading) return 'Cargando...';
    if (selectedIds.length === 0) return placeholder || label || 'Seleccionar';
    if (selectedIds.length === 1) {
      return options.find((o) => o._id === selectedIds[0])?.name ?? '1 seleccionado';
    }
    return `${selectedIds.length} seleccionados`;
  };

  return (
    <div className="select-multiple-with-search" style={{ position: 'relative' }} ref={dropdownRef}>
      <label style={{ fontWeight: 'bold' }}>{label}</label>
      <div
        className="select-box"
        onClick={() => !disabled && !isLoading && setIsOpen((prev) => !prev)}
        style={{ cursor: disabled || isLoading ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1 }}
      >
        <span style={{ fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {getDisplayText()}
        </span>
        <img
          src={pointerDown}
          alt="pointerDown"
          className={`pointer-icon${isOpen ? ' open' : ''}`}
        />
      </div>

      {isOpen && (
        <div className="dropdown-container" style={{ position: 'absolute', zIndex: 1000 }}>
          {options.length > 8 && (
            <input
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-bar"
            />
          )}
          <div className="options-container-multiple">
            <div className="option-multiple">
              <input
                type="checkbox"
                id="msd-select-all"
                checked={allFilteredSelected}
                onChange={handleSelectAll}
                disabled={disabled}
              />
              <label htmlFor="msd-select-all" style={{ fontWeight: 'normal', textAlign: 'initial' }}>
                Seleccionar todo
              </label>
            </div>
            {filteredOptions.map((option) => (
              <div key={option._id} className="option-multiple">
                <input
                  type="checkbox"
                  id={`msd-${option._id}`}
                  value={option._id}
                  checked={selectedIds.includes(option._id)}
                  onChange={() => handleOptionChange(option._id)}
                  disabled={disabled}
                />
                <label htmlFor={`msd-${option._id}`} style={{ fontWeight: 'normal', textAlign: 'initial' }}>
                  {option.name}
                </label>
              </div>
            ))}
            {filteredOptions.length === 0 && (
              <p style={{ padding: '8px', margin: 0, fontSize: '12px', color: '#888' }}>
                Sin resultados
              </p>
            )}
          </div>
          <div className="buttons-container">
            <button
              className="search-button"
              disabled={disabled}
              onClick={handleSearch}
            >
              Buscar
            </button>
            <button
              className="clear-filters-button"
              onClick={handleClear}
              disabled={selectedIds.length === 0}
            >
              Limpiar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export const TableFilter = ({ options, label, disabled, onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const clearFilters = () => {
    setSelectedValues([]);
    onSearch([]);
    setIsOpen(false);
  };

  const handleSearch = () => {
    onSearch(selectedValues);
    setIsOpen(false);
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedValues(filteredOptions.map((option) => option._id));
    } else {
      setSelectedValues([]);
    }
  };

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setSelectedValues((prevSelectedValues) => {
      const newSelectedValues = prevSelectedValues.includes(value)
        ? prevSelectedValues.filter((v) => v !== value)
        : [...prevSelectedValues, value];

      // Desmarcar "Seleccionar todo" si no todas las opciones están seleccionadas
      if (newSelectedValues.length !== filteredOptions.length) {
        setSelectAll(false);
      }
      return newSelectedValues;
    });
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const filtered = options.filter((option) =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered.filter((option) => option !== undefined));
    } else {
      setFilteredOptions(options.filter((option) => option !== undefined));
    }
  }, [searchTerm, options]);

  useEffect(() => {
    setFilteredOptions(options.filter((option) => option !== undefined));
  }, [options]);

  return (
    <div
      className="select-multiple-with-search"
      style={{ position: 'relative' }}
    >
      <img src={filter} alt="filtrar" className="" onClick={handleToggle} />
      {isOpen && (
        <div className="dropdown-container" ref={dropdownRef}>
          {options.length > 15 && (
            <input
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-bar"
              key={'search-bar'}
            />
          )}
          <div className="options-container-multiple">
            <div key={'select-all'} className="option-multiple">
              <input
                type="checkbox"
                id={'select-all'}
                checked={selectAll}
                onChange={handleSelectAllChange}
                disabled={disabled}
              />
              <label
                htmlFor={'select-all'}
                style={{ fontWeight: 'normal', textAlign: 'initial' }}
              >
                {'Seleccionar todo'}
              </label>
            </div>
            {label === 'Asesor Asignado' && (
              <div key={'unnassigned'} className="option-multiple">
                <input
                  type="checkbox"
                  id={'unnassigned'}
                  value={'unnassigned'}
                  checked={selectedValues.includes('unnassigned')}
                  onChange={handleOptionChange}
                  disabled={disabled}
                />
                <label
                  htmlFor={'unnassigned'}
                  style={{ fontWeight: 'normal', textAlign: 'initial' }}
                >
                  {'No asignado'}
                </label>
              </div>
            )}
            {filteredOptions?.map((o) => (
              <div key={o?._id} className="option-multiple">
                <input
                  type="checkbox"
                  id={o?._id}
                  value={o?._id}
                  checked={selectedValues.includes(o?._id)}
                  onChange={handleOptionChange}
                  disabled={disabled}
                />
                <label
                  htmlFor={o?._id}
                  style={{ fontWeight: 'normal', textAlign: 'initial' }}
                >
                  {o?.name}
                </label>
              </div>
            ))}
          </div>
          <div className="buttons-container">
            <button
              className="search-button"
              disabled={disabled}
              onClick={() => handleSearch()}
            >
              Buscar
            </button>
            <button
              className="clear-filters-button"
              onClick={clearFilters}
              disabled={selectedValues.length === 0 ? true : false}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export const OneOptionTableFilter = (props) => {
  const {
    options,
    label,
    name,
    onChange,
    bootstrap,
    errors,
    disabled,
    capitalizeOff,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [textField, setTextField] = useState('');
  const [hovered, setHovered] = useState(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    setFilteredOptions(
      options.filter((o) => o?.name?.toLowerCase().includes(term))
    );
  };

  const handleSelect = (value) => {
    onChange(value);
    setTextField(
      capitalize(filteredOptions.find((o) => o?._id === value)?.name) || ''
    );
    setIsOpen(false);
  };

  useEffect(() => {
    const initialFilteredOptions = options.filter(
      (option) => option !== undefined
    );
    setFilteredOptions(initialFilteredOptions);
  }, [options]);
  return (
    <div
      style={{
        position: 'relative',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
      }}
    >
      <div className="custom-select-container">
        <div
          className={`custom-select ${isOpen ? 'open' : ''}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: 'none',
            textAlign: 'center',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: '400',
            color: '#000',
            marginTop: '16px',
          }}
        >
          <span>{label}</span>

          <img
            src={filter}
            alt="filtrar"
            className=""
            onClick={handleToggle}
            style={{
              cursor: 'pointer',
              // marginTop: '16px',
            }}
          />
        </div>
        {isOpen && (
          <div
            className="custom-select-dropdown"
            style={{
              maxHeight: '210px',
              minWidth: '170px',
              overflowY: 'auto',
              borderRadius: '4px',
              border: '1px solid #ccc',
              padding: '0',
              position: 'absolute',
              fontWeight: '400',
              zIndex: 10,
            }}
          >
            {options?.length > 10 && (
              <input
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={handleSearch}
                className="custom-select-search"
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                  backgroundColor: '#fff',
                  padding: '8px',
                  borderBottom: '1px solid #ccc',
                }}
              />
            )}
            <ul
              className="custom-select-options"
              style={{ padding: '0', margin: 0, width: '100%' }}
            >
              {filteredOptions.map((o) => (
                <li
                  key={o?._id}
                  onClick={() => handleSelect(o?._id)}
                  className="custom-select-option"
                  style={{
                    cursor: 'pointer',
                    listStyle: 'none',
                    padding: '5px',
                    paddingLeft: '10px',
                    margin: 0,
                    backgroundColor: hovered === o?._id ? '#f27730' : '#fff', // Cambiar color
                    color: hovered === o?._id ? '#fff' : '#000',
                  }}
                  onMouseEnter={() => setHovered(o?._id)} // Detectar hover
                  onMouseLeave={() => setHovered(null)}
                >
                  {o?.name}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <p>{errors}</p>
    </div>
  );
};

export const MemoizedOneOptionTableFilter = React.memo(OneOptionTableFilter);

export const TableDateFilter = ({ label, disabled, onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const clearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    onSearch({});
    setIsOpen(false);
  };

  const handleSearch = () => {
    onSearch(startDate, endDate);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className="select-multiple-with-search"
      style={{ position: 'relative' }}
    >
      <img src={filter} alt="filtrar" className="" onClick={handleToggle} />
      {isOpen && (
        <div
          className="dropdown-container"
          ref={dropdownRef}
          style={{ borderRadius: '4px' }}
        >
          <DatePicker
            selected={startDate}
            onChange={handleChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            inline
            className="custom-datepicker"
            calendarClassName="custom-calendar"
          />
          <div
            className="buttons-container"
            style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}
          >
            <button
              className="search-button"
              disabled={disabled}
              onClick={() => handleSearch()}
            >
              Buscar
            </button>
            <button
              className="clear-filters-button"
              onClick={clearFilters}
              disabled={startDate === null && endDate === null ? true : false}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export const TableTextFilter = ({
  label,
  type = 'text',
  placeholder,
  disabled,
  onSearch,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState('');
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const clearFilter = () => {
    setValue('');
    onSearch('');
    setIsOpen(false);
  };

  const handleSearch = () => {
    onSearch(value);
    setIsOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className="select-multiple-with-search"
      style={{ position: 'relative' }}
    >
      <img src={filter} alt="filtrar" className="" onClick={handleToggle} />
      {isOpen && (
        <div className="dropdown-container" ref={dropdownRef}>
          <input
            type={type}
            placeholder={placeholder || label}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            className="search-bar"
            autoFocus
          />
          <div className="buttons-container">
            <button
              className="search-button"
              disabled={disabled}
              onClick={() => handleSearch()}
            >
              Buscar
            </button>
            <button
              className="clear-filters-button"
              onClick={clearFilter}
              disabled={!value}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export const CheckboxInput = (props) => {
  const {
    bootstrap,
    label,
    subLabel,
    errorInput,
    name,
    register,
    errors,
    onChange,
    disabled,
  } = props;

  return (
    <div
      className={`checkbox-input-container input-component-container ${bootstrap}`}
    >
      {label ? <label htmlFor={name}>{label}</label> : ''}
      <div className="checkbox-input-sublabel-container">
        <input
          id={name}
          className={`checkbox-input  ${errorInput}`}
          type={'checkbox'}
          name={name}
          onChange={onChange}
          {...register(name, {
            onChange: onChange,
          })}
          autoComplete="off"
          disabled={disabled}
        />
        <h6>{subLabel}</h6>
      </div>
      {errors && <p>{errors}</p>}
    </div>
  );
};

export const SearchInput = (props) => {
  const { placeholder, width, value, onChange, searchAction } = props;

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      searchAction();
    }
  };

  return (
    <div className="incidence-search">
      <div className="searchImageContainers">
        <img src={search} alt="search" onClick={() => searchAction()} />
      </div>
      <input
        style={{ width: width }}
        className="service-search-input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e)}
        onKeyDown={(e) => handleKeyDown(e)}
      />
    </div>
  );
};

export const SearchInputWithSelector = (props) => {
  const {
    placeholder,
    width,
    value,
    onChange,
    searchAction,
    label,
    setCategory,
    category,
    options,
  } = props;

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      searchAction();
    }
  };

  const handlePressSearch = () => {
    searchAction();
  };

  return (
    <>
      <label
        htmlFor={'span'}
        style={{
          fontWeight: 'bold',
          fontSize: '16px',
          marginBottom: '0.2rem',
        }}
      >
        {label}
      </label>
      <div className="incidence-search">
        <div className="search-item-container">
          <select
            name="options"
            id="options"
            onChange={(e) => setCategory(e.target.value)}
            value={category}
          >
            {options?.map((o) => (
              <option key={o?._id} value={o?._id}>
                {o?.name}
              </option>
            ))}
          </select>
        </div>
        <input
          style={{ width: width, borderRadius: '0px' }}
          className="membership-search-input"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e)}
          onKeyDown={(e) => handleKeyDown(e)}
        />
        <div className="search-image-button">
          <img src={search} alt="search" onClick={() => handlePressSearch()} />
        </div>
      </div>
    </>
  );
};

export const EditAndSaveInput = (props) => {
  const { placeholder, width, saveAction, id, initialValue } = props;
  const [editIcon, setEditIcon] = useState(false);
  const [value, setValue] = useState(initialValue);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      saveAction({
        id,
        observation: value,
      });
      setEditIcon(!editIcon);
    }
  };

  return (
    <div
      className="incidence-search"
      style={{
        backgroundColor: 'transparent',
      }}
    >
      <div
        className="searchImageContainers"
        onClick={() => setEditIcon(!editIcon)}
        style={{
          backgroundColor: '#E0E1E1',
        }}
      >
        <img
          src={edit}
          alt="edit"
          style={{ display: editIcon ? 'none' : 'block' }}
        />
        {editIcon && (
          <img
            src={save}
            alt="save"
            onClick={() =>
              saveAction({
                id,
                observation: value,
              })
            }
          />
        )}
      </div>
      <input
        disabled={!editIcon}
        style={{ width: width }}
        className="service-search-input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => handleKeyDown(e)}
      //add as initial text the value of the input
      />
    </div>
  );
};

export const ChangeAdvisorInput = (props) => {
  const { placeholder, saveAction, id, initialValue, list, cancelImg } = props;
  const [reloadValue, setReloadValue] = useState(initialValue);

  // seller ? initialValue || sellerName : initialValue || null
  const [value, setValue] = useState(initialValue);
  let user = localStorage.getItem('user');
  user = JSON.parse(user);

  useEffect(() => {
    setValue(reloadValue);
  }, [reloadValue]);

  const handleSelectChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    saveAction({
      id,
      assignedAdvisor: newValue,
    });
  };

  const handleAssignMyself = () => {
    setValue(user?._id);
    saveAction({
      id,
      assignedAdvisor: user?._id,
    });
    setReloadValue(capitalize(`${user?.firstName} ${user?.lastName}`));
  };

  return (
    <div
      className="advisor-container"
      style={{
        backgroundColor: 'transparent',
      }}
    >
      {reloadValue ? (
        <>
          <p
            style={{
              display: 'flex',
              marginTop: '1rem',
              marginRight: '0.3rem',
              cursor: 'pointer',
            }}
            onClick={() => {
              handleSelectChange({ target: { value: null } });
              setReloadValue(null);
            }}
          >
            <img src={cancelImg} alt="edit" />
          </p>
          <select
            name="change-advisor"
            placeholder={placeholder}
            className="assing-advisor-select"
            id="advisor"
            onChange={handleSelectChange}
            value={value || ''}
          >
            {reloadValue && <option value="">{capitalize(reloadValue)}</option>}
            {list.map((advisor, index) => (
              <option key={index} value={advisor._id}>
                {capitalize(advisor.firstName)}
              </option>
            ))}
          </select>
        </>
      ) : (
        <div className="assing-myself-button" onClick={handleAssignMyself}>
          <p className="assing-myself-text">Asignarme</p>
        </div>
      )}
    </div>
  );
};

export const ChangeCampaingActionsInput = (props) => {
  const { placeholder, saveAction, id, initialValue, list } = props;
  const [value, setValue] = useState(initialValue);
  const filteredList = Object.values(list);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSelectChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    saveAction({
      id,
      campaignAction: newValue,
    });
  };

  return (
    <div
      className="advisor-container"
      style={{
        backgroundColor: 'transparent',
      }}
    >
      <select
        name="change-action"
        placeholder={placeholder}
        className="assing-campaing-select"
        id="advisor"
        onChange={handleSelectChange}
        value={value || ''}
      >
        {initialValue && <option value="">{capitalize(initialValue)}</option>}
        {filteredList.map((action, index) => (
          <option key={index} value={action}>
            {action}
          </option>
        ))}
      </select>
    </div>
  );
};

export const ChangeSituationInput = (props) => {
  const { placeholder, saveAction, id, initialValue, list } = props;
  const [value, setValue] = useState(initialValue);
  const filteredList = Object.values(list);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSelectChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    saveAction({
      id,
      situation: newValue,
    });
  };

  return (
    <div
      className="advisor-container"
      style={{
        backgroundColor: 'transparent',
      }}
    >
      <select
        name="change-situation"
        placeholder={placeholder}
        className="assing-campaing-select"
        id="situation"
        onChange={handleSelectChange}
        value={value || ''}
      >
        <option value=""></option>
        {filteredList.map((situation, index) => (
          <option key={index} value={situation}>
            {situation}
          </option>
        ))}
      </select>
    </div>
  );
};

export const SelectProvider = (props) => {
  const { onChange, bootstrap, label, name, options, errors, value } = props;

  return (
    <div className={`input-component-container ${bootstrap}`}>
      <label htmlFor={name}>{label}</label>
      <div>
        <select
          className="input-select"
          onChange={onChange}
          value={value}
          name={name}
        >
          <option value=""></option>
          {options?.map((o, i) => {
            if (o?.status === providerStatus.available) {
              return (
                <option key={o?._id} value={o?._id}>
                  {capitalize(o?.contactName?.toLowerCase())}
                  &nbsp;&nbsp;(
                  {translateStatus(o?.status)})
                </option>
              );
            } else {
              return (
                <option style={{ color: 'red' }} key={o?._id} value={o?._id}>
                  {capitalize(o?.contactName?.toLowerCase()) + '   '}
                  &nbsp;&nbsp;(
                  {translateStatus(o?.status)})
                </option>
              );
            }
          })}
        </select>
      </div>

      <p>{errors}</p>
    </div>
  );
};

export const PaymentSection = (props) => {
  const {
    payment,
    watch,
    options,
    register,
    index,
    returnAccountData,
    fileUploaded,
    setFileUploaded,
    onChange,
  } = props;

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        // Do whatever you want with the file contents
      };
      reader.readAsArrayBuffer(file);

      if (
        !['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(
          file.type
        )
      ) {
        notify('Agregar un formato valido de imagen', 'error');
        return null;
      }
      let maxWeight = 3;
      if (file.size * 0.000001 > maxWeight) {
        notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
      } else {
        let files = fileUploaded;
        files[index] = acceptedFiles[0];

        setFileUploaded([...files]);
      }
    });
  }, []);

  const removeFile = (index) => {
    let files = fileUploaded;
    files[index] = '';
    setFileUploaded([...files]);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const validateOnChangeUSD_BsS = (name) => {
    if (name?.includes('amount') && !name?.includes('BsS')) {
      return onChange?.handleAmountChange;
    }
  };

  return (
    <>
      {payment?.label === 'IGTF' ? (
        <IGTFComponent
          amount={watch(`amount${payment?.counter}`)}
          method={
            options?.paymentMethods?.filter(
              (o) => o?._id === watch(`method${payment?.counter}`)
            )[0]
          }
        />
      ) : (
        <Input
          key={payment?.label}
          bootstrap={payment?.bootstrap}
          label={payment?.label}
          type={payment?.type}
          name={payment?.name}
          register={register}
          placeholder={''}
          errors={payment?.errors}
          options={options?.paymentMethods}
          min={'1'}
          disabled={payment?.disabled}
          onChange={validateOnChangeUSD_BsS(payment?.name)}
        />
      )}

      {watch(`${payment?.name}`) && payment?.type === 'select' && (
        <CopyToClipboard
          text={returnAccountData(
            options.paymentMethods,
            watch(`${payment?.name}`)
          )}
        >
          <div className="col-5 copy-payment-data-image-button-container">
            <img
              className="copy-payment-data-image-button"
              src={copyImage}
              alt="copyImage"
            />
            <h6>Copiar datos de pago</h6>
          </div>
        </CopyToClipboard>
      )}

      {payment?.dropzone && (
        <div className="col-12">
          <label className="dropzone-label">{payment?.label}</label>
          {fileUploaded[index] ? (
            <FileComponent
              file={fileUploaded[index]}
              remove={() => removeFile(index)}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              message={'(PNG, JPG, JEPG, máx. 3MB)'}
            />
          )}
        </div>
      )}
    </>
  );
};

export const CheckboxComponent = (props) => {
  const { label, selected, onSelect } = props;
  return (
    <div className="checkbox-component-container">
      <h6 htmlFor="">{label}</h6>
      {selected ? (
        <img onClick={() => onSelect(!selected)} src={checkboxChecked} alt="" />
      ) : (
        <img onClick={() => onSelect(!selected)} src={checkbox} alt="" />
      )}
    </div>
  );
};

export const ValidateCheckboxComponent = (props) => {
  const { label, selected, onSelect } = props;
  return (
    <div className="checkbox-component-container">
      <h6 htmlFor="">{label}</h6>
      {selected ? (
        <img onClick={() => onSelect(label)} src={checkboxChecked} alt="" />
      ) : (
        <img onClick={() => onSelect(label)} src={checkbox} alt="" />
      )}
    </div>
  );
};

export const IGTFComponent = (props) => {
  const { method, amount } = props;

  if (amount && method && method?.currency !== 'BsS') {
    return (
      <div className="monto-con-igtf col-12">
        <h6>Monto con recargo de IGTF {returnIGTF()}%</h6>
        <h5>
          {(
            parseFloat(amount) +
            (parseFloat(amount) * returnIGTF()) / 100
          )?.toFixed(2)}{' '}
          (USD)
        </h5>
      </div>
    );
  } else return null;
};

export const CheckboxTable = ({ value, action, name, index, disabled }) => {
  if (disabled) {
    return (
      <img
        className="checkbox-table"
        src={checkboxIndeterminate}
        alt="checkboxDisabled"
        onClick={() => { }}
      />
    );
  }

  if (value) {
    return (
      <img
        className="checkbox-table"
        src={checkboxChecked}
        alt="checkboxChecked"
        onClick={() => action(name, value, index)}
      />
    );
  }

  return (
    <img
      className="checkbox-table"
      src={checkbox}
      alt="checkbox"
      onClick={() => action(name, value, index)}
    />
  );
};

export const SelectTable = (props) => {
  const {
    options,
    label,
    name,
    index,
    value,
    onChange,
    disabled,
    backgroundColor,
  } = props;
  return (
    <div className="table-select">
      <label htmlFor="label">{label}</label>
      <select
        style={{ backgroundColor: backgroundColor || '#f27730' }}
        disabled={disabled}
        name={name}
        id="label"
        onChange={(e) => onChange(name, e.target.value, index)}
        value={value}
      >
        <option value={''}></option>
        {options?.map((o) => (
          <option key={o?.name} value={o?._id || o?.id}>
            {o?.name || o?.code}
          </option>
        ))}
      </select>
    </div>
  );
};

export const InputTable = (props) => {
  const { placeholder, width, saveAction, name, index, initialValue } = props;
  const [editIcon, setEditIcon] = useState(false);
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue || '');
  }, [initialValue]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      saveAction(name, value, index);
      setEditIcon(!editIcon);
    }
  };

  return (
    <div
      className="incidence-search"
      style={{
        backgroundColor: 'transparent',
      }}
    >
      <div
        className="searchImageContainers"
        onClick={() => setEditIcon(!editIcon)}
        style={{
          backgroundColor: '#E0E1E1',
        }}
      >
        <img
          src={edit}
          alt="edit"
          style={{ display: editIcon ? 'none' : 'block' }}
        />
        {editIcon && (
          <img
            src={save}
            alt="save"
            onClick={() => saveAction(name, value, index)}
          />
        )}
      </div>
      <input
        disabled={!editIcon}
        style={{ width: width }}
        className="service-search-input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => handleKeyDown(e)}
      />
    </div>
  );
};

export const SearchInputV2 = (props) => {
  const {
    placeholder,
    width,
    value,
    onChange,
    searchAction,
    onSelectOption,
    error,
  } = props;
  const [options, setOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSelected, setIsSelected] = useState(!!value);
  const isTypingRef = useRef(false);

  useEffect(() => {
    if (!value) {
      setIsSelected(false);
    } else if (!isTypingRef.current) {
      setIsSelected(true);
    }
    isTypingRef.current = false;
  }, [value]);

  const handleSearch = async (searchValue) => {
    if (searchAction) {
      setLoading(true);
      try {
        const res = await searchAction(value ?? searchValue);
        if (res && Array.isArray(res)) {
          setOptions(res);
          setShowOptions(true);
        } else if (res && res.data && Array.isArray(res.data)) {
          setOptions(res.data);
          setShowOptions(true);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      console.log(
        'Enter presionado, iniciando búsqueda con valor:',
        event.target.value
      );
      handleSearch(event.target.value);
    }
  };

  const handleSelect = (opt) => {
    setShowOptions(false);
    console.log('Opción seleccionada:', opt);
    setIsSelected(true);
    if (onChange) {
      // Simulamos el evento onChange para que el componente padre actualice el estado del input
      onChange({ target: { value: { _id: opt?._id, name: opt?.name } } });
    }
    if (onSelectOption) {
      onSelectOption(opt);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setIsSelected(false);
    if (onChange) {
      onChange({ target: { value: { _id: '', name: '' } } });
    }
    if (onSelectOption) {
      onSelectOption(null);
    }
  };

  return (
    <div
      style={{
        position: 'relative',
        width: width || '100%',
        marginBottom: '16px',
      }}
    >
      <style>
        {`
          @keyframes spin-loader {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <input
        style={{
          width: '100%',
          padding: '10px 12px',
          paddingRight: '36px',
          border: '1px solid #ddd',
          borderRadius: '6px',
          fontSize: '14px',
          color: '#444',
          outline: 'none',
          boxSizing: 'border-box',
          backgroundColor: loading ? '#f5f5f5' : '#fff',
        }}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          isTypingRef.current = true;
          onChange(e);
          setShowOptions(false);
          setIsSelected(false);
        }}
        onKeyDown={(e) => handleKeyDown(e)}
        disabled={loading}
      />
      <div
        style={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: loading ? 'default' : 'pointer',
        }}
        onClick={(e) => {
          if (loading) return;
          if (isSelected) handleClear(e);
          else handleSearch();
        }}
      >
        {loading ? (
          <div
            style={{
              width: '16px',
              height: '16px',
              border: '2px solid #ddd',
              borderTopColor: '#ff7020', // Color naranja principal del sitio
              borderRadius: '50%',
              animation: 'spin-loader 0.8s linear infinite',
            }}
          ></div>
        ) : isSelected ? (
          <svg
            style={{ opacity: 0.6 }}
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        ) : (
          <img
            src={search}
            alt="search"
            style={{ opacity: 0.5, width: '18px', height: '18px' }}
          />
        )}
      </div>

      {showOptions && options.length > 0 && (
        <ul
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: '#fff',
            border: '1px solid #ddd',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            listStyle: 'none',
            margin: '4px 0 0 0',
            padding: 0,
            zIndex: 100,
            maxHeight: '200px',
            overflowY: 'auto',
          }}
        >
          {options.map((opt, idx) => (
            <li
              key={opt?.id || opt?._id || idx}
              style={{
                padding: '10px 12px',
                borderBottom:
                  idx === options.length - 1 ? 'none' : '1px solid #eee',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#333',
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#f5f5f5')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(opt);
              }}
            >
              {opt?.name || opt?.label || opt || 'Opción'}
            </li>
          ))}
        </ul>
      )}
      {error && <p className="surcharges-form__error-message">{error}</p>}
    </div>
  );
};

export const CheckboxInputV2 = (props) => {
  const {
    options,
    name,
    register,
    selectedValues = [],
    onChange,
    disabled = false,
  } = props;

  const handleToggle = (value) => {
    if (disabled) return;
    const newSelectedValues = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    if (onChange) {
      onChange(newSelectedValues);
    }
  };

  return (
    <div className="surcharges-form__radio-group">
      {options?.map((option) => {
        const isSelected = selectedValues.includes(option.value);
        return (
          <label
            key={option.value}
            className={`surcharges-form__radio-card ${isSelected ? 'surcharges-form__radio-card--active' : ''}`}
            style={{
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1,
            }}
          >
            <input
              type="checkbox"
              value={option.value}
              {...(register
                ? register(name, {
                  onChange: () => handleToggle(option.value),
                })
                : {
                  onChange: () => handleToggle(option.value),
                  checked: isSelected,
                })}
              disabled={disabled}
            />
            <div className="surcharges-form__radio-text">
              <span
                className="surcharges-form__radio-title"
                style={{ color: isSelected ? '#005ce6' : '' }}
              >
                {option.title}
              </span>
              {option.subtitle && (
                <span
                  className="surcharges-form__radio-subtitle"
                  style={{ color: isSelected ? '#8cb3ff' : '' }}
                >
                  {option.subtitle}
                </span>
              )}
            </div>
          </label>
        );
      })}
    </div>
  );
};
